import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StatusChangeOrdersComponent } from 'history/statuses-history/status-change-orders/status-change-orders.component';
import { StatusChangeComponent } from 'history/statuses-history/status-change/status-change.component';
import { StatusesHistoryComponent } from 'history/statuses-history/statuses-history.component';
import { StatusChangeResolver } from './statuses-history-resolvers';

export { StatusChangeResolver } from './statuses-history-resolvers';

const routes: Routes = [
  {
    path: '',
    component: StatusesHistoryComponent,
    data: { title: 'PAGE_TITLES.status_history' },
  },
  {
    path: ':changeGroupId',
    component: StatusChangeComponent,
    resolve: {
      statusChange: StatusChangeResolver,
    },
    data: { title: 'PAGE_TITLES.status_groups' },
    children: [
      {
        path: ':statusChangeId',
        component: StatusChangeOrdersComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StatusesHistoryRoutingModule {
}
